var map = {
	"./de-DE/dataset": 86643,
	"./en-US/dataset": 90512,
	"./es-ES/dataset": 15177,
	"./fa-IR/dataset": 55649,
	"./fr-FR/dataset": 99653,
	"./hi-IN/dataset": 35827,
	"./it-IT/dataset": 1003,
	"./ja-JP/dataset": 26464,
	"./ko-KR/dataset": 23862,
	"./pl-PL/dataset": 25737,
	"./pt-BR/dataset": 69601,
	"./ro-RO/dataset": 58987,
	"./ru-RU/dataset": 65551,
	"./sl-SI/dataset": 38584,
	"./th-TH/dataset": 19217,
	"./tr-TR/dataset": 74833,
	"./uk-UA/dataset": 29211,
	"./vi-VN/dataset": 50842,
	"./zh-Hans/dataset": 86543,
	"./zh-Hant/dataset": 18778
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 27611;